import { List, Record } from "immutable";

import createFromJS from "../../../createFromJS";
import { InsetRecord } from "../../helper/InsetRecord";

export const UIStateRecord = Record({
  isEditMode: false,
  isEntityEditMode: false,
  settingsModalOpen: false,
  printPreviewModalOpen: false,
  preferencesModalOpen: false,
  syncSettingsModalOpen: false,
  backupModalOpen: false,
  aboutModalOpen: false,
  exportImagePreviewModalOpen: false,
  exportTsfModalOpen: false,
  exportCsvModalOpen: false,
  importCsvModalOpen: false,
  saveTemplateModalOpen: false,
  inspectorModalOpen: false,
  fileVersionTooLowModalOpen: false,
  openFileAllowReadonly: false,
  sampleModalOpen: false,
  savedFiltersExpanded: false,
  searchReplaceExpanded: false,
  searchCaseSensitive: false,
  searchWholeWord: false,
  searchValue: "",
  replaceValue: "",
  excludeSearchFields: List(),

  floatingNotification: null,
  pulsateIcon: null,
  menuPopoverType: null,
  fileName: null,
  showGlobalFilterPanel: true,

  leftPanelHasChildPopover: false,

  syncInProgress: false,
  syncProgressLabel: null,
  syncProgressPercent: 0.0,

  // Track the insets of the device to make sure we account for the notch
  // in iPhone X and later
  deviceInsets: InsetRecord()
});

const data = {
  objects: {
    excludeSearchFields: "List",
    deviceInsets: "InsetRecord",
    floatingNotification: "UINotificationRecord"
  }
};
createFromJS.registerCallback("UIStateRecord", createFromJS.createNestedCallback(UIStateRecord, data));
